<template>
  <div>
    <SummaryReportOfStudentsProgressTable ref="groupSummaryReportOfStudentsProgressTable"></SummaryReportOfStudentsProgressTable>
  </div>
</template>
<style>
.dropped td {
  background-color: #F64E60;
}
</style>
<script>
import SummaryReportOfStudentsProgressTable from "@/views/pages/edu/schools/reports/partials/SummaryReportOfStudentsProgressTable.vue";
export default {
  name: "GroupSummaryReportOfStudentsProgressReport",
  components: {
    SummaryReportOfStudentsProgressTable
  },
  props:{
    groupId:String
  },
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {    
    reloadData(){
      this.$refs['groupSummaryReportOfStudentsProgressTable'].redrawTable(parseInt(this.groupId));
    }
  }
};
</script>
